/**
 * True when targetSkuStripped is a child listed on this PDP's variants.
 * Used to skip availability hard-navigation: child catalog URLs often
 * canonicalize back to the master PDP and clear option selections.
 *
 * @param {unknown} variants
 * @param {string} targetSkuStripped
 * @returns {boolean}
 */
function isListedVariantSku(variants, targetSkuStripped) {
	if (!Array.isArray(variants) || typeof targetSkuStripped !== 'string' || targetSkuStripped === '') {
		return false;
	}

	return variants.some((variant) => {
		const sku = variant?.product?.sku_stripped;
		return typeof sku === 'string' && sku === targetSkuStripped;
	});
}

/**
 * Skip availability hard-navigation when already on the master PDP target,
 * or when selecting a listed child (child URLs often canonicalize back to master).
 *
 * @param {object} params
 * @param {string} [params.masterSkuStripped]
 * @param {string} params.targetSkuStripped
 * @param {unknown} [params.variants]
 * @returns {boolean}
 */
function shouldSkipVariantAvailabilityRedirect({ masterSkuStripped, targetSkuStripped, variants }) {
	if (typeof targetSkuStripped !== 'string' || targetSkuStripped === '') {
		return false;
	}

	if (typeof masterSkuStripped === 'string' && masterSkuStripped !== '' && targetSkuStripped === masterSkuStripped) {
		return true;
	}

	return isListedVariantSku(variants, targetSkuStripped);
}

module.exports = {
	isListedVariantSku,
	shouldSkipVariantAvailabilityRedirect,
};
